// extracted by mini-css-extract-plugin
module.exports = {"container":"base_container__zs4Az","no-layout":"base_no-layout__Wy3fC","no-header":"base_no-header__Z_OCE","no-footer":"base_no-footer__rwSwD"};